export const executive = {
    en: {
        titles: {
            dash: 'Executive Reports',
            new: 'New Executive Report',
            edit: 'Edit Executive Report',
            confirm: 'Delete Executive Report'
        },
        subtitles: {
            excel: 'Excel',
            graphs: 'Graphs'
        },
        actions: {
            new: 'New report',
            search: 'Search',
            save: 'Save',
            cancel: 'Cancel',
            delete: 'Delete',
            example: 'Example'
        },
        examples: [{
                label: 'Example Excel',
                file: 'gstmv3_ex-weekly-executive-report.xlsx'
            },
            {
                label: 'Example PDF',
                file: 'gstmv3_ex-weekly-executive-report.pdf'

            }
        ],
        tables: {
            pager: ['Page', 'of', 'row(s) per page'],
            data: ['No data available in table', 'No matching records found'],
            columns: ['Name', 'Email', 'Occurance', 'Excel', 'Graphs', 'Devices'],
        },
        forms: {
            name: {
                label: 'Name',
                placeholder: 'Ex. Report manager',
                required: 'Name is required',
                minLength: 'Name must be at lest {0} characters',
                maxLength: 'Name must be less than {0} characters',
                error: ''
            },
            frequency: {
                label: 'Frequency',
                placeholder: 'Frequency',
                required: 'Frequency is required',
                error: '',
                options: {
                    1: {
                        value: 1,
                        label: 'Per day',
                        alt: 'Daily'
                    },
                    7: {
                        value: 7,
                        label: 'Per week',
                        alt: 'Weekly'
                    },
                    30: {
                        value: 30,
                        label: 'Per month',
                        alt: 'Monthly'
                    }
                }
            },
            devices: {
                label: 'Devices',
                placeholder: 'Devices',
                required: 'Devices is required',
                error: ''
            },
            groups: {
                label: 'Group',
                placeholder: 'Group',
                required: 'Group is required',
                error: ''
            },
            email: {
                label: 'Email',
                placeholder: 'Ex. example@domain.com',
                required: 'Email is required',
                error: ''
            },
            excel: {
                label: 'Excel',
                all: {
                    label: 'All',
                    active: false,
                },
                options: [{
                        key: 'events',
                        label: 'Events',
                        active: false,
                    },
                    {
                        key: 'stops',
                        label: 'Stops',
                        active: false,
                    },
                    {
                        key: 'firstlast',
                        label: 'First on/Last off',
                        active: false,
                    },
                    {
                        key: 'battery',
                        label: 'Battery disconnect',
                        active: false,
                    },
                    {
                        key: 'door',
                        label: 'Open door',
                        active: false,
                    },
                    {
                        key: 'engine',
                        label: 'Engine cycles',
                        active: false,
                    },
                    {
                        key: 'panic',
                        label: 'SOS button',
                        active: false,
                    },
                    {
                        key: 'speeding',
                        label: 'Speeding',
                        active: false,
                    },
                    {
                        key: 'posted',
                        label: 'Posted speeds',
                        active: false,
                    },
                    {
                        key: 'rpm',
                        label: 'RPM\'s',
                        active: false,
                    },
                    {
                        key: 'geofence',
                        label: 'Geofence entry/exit',
                        active: false,
                    },
                    {
                        key: 'timemiles',
                        label: 'Time/miles in geofence',
                        active: false,
                    },
                    {
                        key: 'pto',
                        label: 'PTO',
                        active: false,
                    },
                    {
                        key: 'schedules',
                        label: 'Maintenance schedules',
                        active: false,
                    },
                    {
                        key: 'performed',
                        label: 'Maintenance performed',
                        active: false,
                    },
                    {
                        key: 'errorcodes',
                        label: 'Engine error codes',
                        active: false,
                    },
                    {
                        key: 'breakdown',
                        label: 'Speed Breakdown',
                        active: false,
                    },
                    {
                        key: 'ifta',
                        label: 'IFTA',
                        active: false,
                    },
                    {
                        key: 'productivity',
                        label: 'Productivity',
                        active: false,
                    },
                    {
                        key: 'cameraevents',
                        label: 'Camera events',
                        active: false,
                    },
                ]
            },
            graphs: {
                label: 'Graphs',
                all: {
                    label: 'All',
                    active: false,
                },
                periods: [{
                        key: 'day',
                        label: 'Per day',
                        active: false
                    },
                    {
                        key: 'device',
                        label: 'Per device',
                        active: false
                    },
                    {
                        key: 'deviceday',
                        label: 'Per device per day',
                        active: false
                    },
                ],
                options: [{
                        key: 'idle',
                        label: 'Idle',
                        active: false,
                        value: ''
                    },
                    {
                        key: 'odo',
                        label: 'Odometer',
                        active: false,
                        value: ''
                    },
                    {
                        key: 'agressive',
                        label: 'Agressive driving',
                        active: false,
                        value: '',
                    },
                    {
                        key: 'pto',
                        label: 'PTO/Open door/Sweeper',
                        active: false,
                        value: '',
                    },
                    {
                        key: 'speeding',
                        label: 'Speeding',
                        active: false,
                        value: ''
                    },
                    {
                        key: 'posted',
                        label: 'Posted speed',
                        active: false,
                        value: ''
                    },
                ]
            },
			days: {
                label: 'Send the',
                placeholder: 'Day',
                required: '',
                error: ''
            },
        },
        notifications: {
            create: 'Report was created successfully',
            edit: 'Report was edited successfully',
            delete: 'Report was deleted successfuly',
            confirm: 'Do you want to delete _EXECUTIVE_ from the list?'
        },
    },
    es: {
        titles: {
            dash: 'Reportes Ejecutivos',
            new: 'Nuevo Reporte Ejecutivo',
            edit: 'Editar Reporte Ejecutivo',
            confirm: 'Eliminar Reporte Ejecutivo'
        },
        subtitles: {
            excel: 'Excel',
            graphs: 'Gráficas'
        },
        actions: {
            new: 'Nuevo reporte',
            search: 'Buscar',
            save: 'Guardar',
            cancel: 'Cancelar',
            delete: 'Eliminar',
            example: 'Ejemplo'
        },
        examples: [{
                label: 'Ejemplo Excel',
                file: 'gstmv3_ej-reporte-ejecutivo-semanal.xlsx'
            },
            {
                label: 'Ejemplo PDF',
                file: 'gstmv3_ej-reporte-ejecutivo-semanal.pdf'

            }
        ],
        tables: {
            pager: ['Página', 'de', 'fila(s) por página'],
            data: ['No hay datos disponibles en la tabla', 'No se encontraron registros coincidentes'],
            columns: ['Nombre', 'Correo', 'Ocurrencia', 'Excel', 'Gráficas', 'Dispositivos'],
        },
        forms: {
            name: {
                label: 'Nombre',
                placeholder: 'Ej. Reporte general',
                required: 'Nombre es requerido',
                minLength: 'Nombre debe tener al menos {0} caracteres',
                maxLength: 'Nombre debe tener máximo {0} caracteres',
                error: ''
            },
            frequency: {
                label: 'Frecuencia',
                placeholder: 'Frecuencia',
                required: 'Frecuencia es requerido',
                error: '',
                options: {
                    1: {
                        value: 1,
                        label: 'Por día',
                        alt: 'Diario'
                    },
                    7: {
                        value: 7,
                        label: 'Por semana',
                        alt: 'Semanal'
                    },
                    30: {
                        value: 30,
                        label: 'Por mes',
                        alt: 'Mensual'
                    }
                }
            },
            devices: {
                label: 'Dispositivos',
                placeholder: 'Dispositivos',
                required: 'Dispositivos es requerido',
                error: ''
            },
            groups: {
                label: 'Grupo',
                placeholder: 'Grupo',
                required: 'Grupo es requerido',
                error: ''
            },
            email: {
                label: 'Correo',
                placeholder: 'Ej. ejemplo@dominio.com',
                required: 'Correo es requerido',
                error: ''
            },
            excel: {
                label: 'Excel',
                all: {
                    label: 'Todos',
                    active: false,
                },
                options: [{
                        key: 'events',
                        label: 'Eventos',
                        active: false,
                    },
                    {
                        key: 'stops',
                        label: 'Paradas',
                        active: false,
                    },
                    {
                        key: 'firstlast',
                        label: 'Primero encendido/Último apagado',
                        active: false,
                    },
                    {
                        key: 'battery',
                        label: 'Desconexión de batería',
                        active: false,
                    },
                    {
                        key: 'door',
                        label: 'Puerta abierta',
                        active: false,
                    },
                    {
                        key: 'engine',
                        label: 'Ciclos del motor',
                        active: false,
                    },
                    {
                        key: 'panic',
                        label: 'Botón de pánico',
                        active: false,
                    },
                    {
                        key: 'speeding',
                        label: 'Exceso de velocidad',
                        active: false,
                    },
                    {
                        key: 'posted',
                        label: 'Limite de Calle Excedido',
                        active: false,
                    },
                    {
                        key: 'rpm',
                        label: 'RPM\'s',
                        active: false,
                    },
                    {
                        key: 'geofence',
                        label: 'Entrada/Salida de geocerca',
                        active: false,
                    },
                    {
                        key: 'timemiles',
                        label: 'Tiempo/km en geocercas',
                        active: false,
                    },
                    {
                        key: 'pto',
                        label: 'PTO',
                        active: false,
                    },
                    {
                        key: 'schedules',
                        label: 'Programas de mantenimiento',
                        active: false,
                    },
                    {
                        key: 'performed',
                        label: 'Mantenimiento realizado',
                        active: false,
                    },
                    {
                        key: 'errorcodes',
                        label: 'Códigos de error del motor',
                        active: false,
                    },
                    {
                        key: 'breakdown',
                        label: 'Desglose de velocidad',
                        active: false,
                    },
                    {
                        key: 'ifta',
                        label: 'IFTA',
                        active: false,
                    },
                    {
                        key: 'productivity',
                        label: 'Paradas laborales',
                        active: false,
                    },
                    {
                        key: 'cameraevents',
                        label: 'Eventos de cámaras',
                        active: false,
                    },
                ]
            },
            graphs: {
                label: 'Gráficas',
                all: {
                    label: 'Todos',
                    active: false,
                },
                periods: [{
                        key: 'day',
                        label: 'Por día',
                        active: false
                    },
                    {
                        key: 'device',
                        label: 'Por dispositivo',
                        active: false
                    },
                    {
                        key: 'deviceday',
                        label: 'Por dispositivo por día',
                        active: false
                    },
                ],
                options: [{
                        key: 'idle',
                        label: 'Inactivo',
                        active: false,
                        value: ''
                    },
                    {
                        key: 'odo',
                        label: 'Odómetro',
                        active: false,
                        value: ''
                    },
                    {
                        key: 'agressive',
                        label: 'Conducción agresiva',
                        active: false,
                        value: '',
                    },
                    {
                        key: 'pto',
                        label: 'PTO/Puerta abierta/Barredora',
                        active: false,
                        value: '',
                    },
                    {
                        key: 'speeding',
                        label: 'Exceso de velocidad',
                        active: false,
                        value: ''
                    },
                    {
                        key: 'posted',
                        label: 'Limite de Calle Excedido',
                        active: false,
                        value: ''
                    },
                ]
            },
			days: {
                label: 'Enviar el',
                placeholder: 'Día',
                required: '',
                error: ''
            },
        },
        notifications: {
            create: 'El reporte se creó con éxito',
            edit: 'El reporte se editó correctamente',
            delete: 'El reporte se eliminó correctamente',
            confirm: '¿Desea eliminar _EXECUTIVE_ de la lista'
        },
    }
}
